import {useEffect} from 'react';
import {useInView} from 'react-intersection-observer';
import {SchemeLink} from '../../../../applink/SchemeLink';
import {UrlLink} from '../../../../applink/UrlLink';
import {t} from '../../../../common/getTranslations';
import {formatWithCommas} from '../../../../common/shared/utils/formatWithCommas';
import {Text} from '../../../../design-system/atoms/Text/Text';
import {PromotionBannerItem} from '../../../../design-system/organisms/PromotionBannerItem/PromotionBannerItem';
import {ShortcutButton} from '../../../../design-system/organisms/ShortcutButton/ShortcutButton';
import {ShortcutHomeButton} from '../../../../design-system/organisms/ShortcutHomeButton/ShortcutHomeButton';
import {ShortcutListQuery} from '../../../../graphql/generated/types';
import {aggregateAndSendLog} from '../../../../logging/aggregateAndSendLog';
import {LOG_CLICK_EVENT} from '../../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {SHORTCUT_TEXT_MAP} from '../constant';

export function ShortcutListContainer({data}: {data: ShortcutListQuery}) {
  const promotionBanner = data?.shortcutList?.promotionBanner;
  const menuList = data?.shortcutList?.menuList;
  const shortcutList = data?.shortcutList?.shortcutList;

  const {ref, inView, entry} = useInView();
  useEffect(() => {
    if (inView && entry?.target) {
      aggregateAndSendLog({
        targetElem: entry.target as HTMLElement,
        actionType: 'ViewImp',
        actionName: '프로모션배너_노출',
        customProps: {
          user_action: 'imp',
        },
        viewimp_contents: {
          imp_id: 'spromo_b_001',
          imp_provider: 'service',
          imp_type: 'vimp',
          layer1: '프로모션',
        },
      });
    }
  }, [entry, inView]);

  if (!data) return null;
  return (
    <div className="py-10pxr">
      {promotionBanner && (
        <div className="px-11pxr pb-8pxr">
          <div
            ref={ref}
            {...putTiaraObjectProps({
              click: {
                ...promotionBanner.eventLog?.click,
                imp_id: 'spromo_b_001',
                imp_provider: 'service',
                layer1: '프로모션',
              },
              customProps: {
                ...promotionBanner.eventLog?.customProps,
              },
              eventMeta: {
                ...promotionBanner.eventLog?.eventMeta,
              },
            })}
            onClickCapture={e => LOG_CLICK_EVENT('프로모션배너_클릭', e)}
          >
            <SchemeLink scheme={promotionBanner.scheme}>
              <PromotionBannerItem
                bannerTitle={promotionBanner?.title}
                leftImageUrl={promotionBanner.leftImage}
                rightImageUrl={promotionBanner.rightImage ?? undefined}
              />
            </SchemeLink>
          </div>
        </div>
      )}
      <div className="px-20pxr pt-10pxr">
        <div className="flex space-x-10pxr">
          {menuList?.map((menuItem, index) => {
            if (
              !menuItem ||
              !menuItem.shortcutHomeType ||
              !menuItem.shortcutHomeUrl
            )
              return;
            return (
              <div
                key={index}
                {...putTiaraObjectProps({
                  click: {
                    layer1: '바로가기',
                    copy: SHORTCUT_TEXT_MAP[menuItem.shortcutHomeType].text,
                  },
                })}
                onClickCapture={e => LOG_CLICK_EVENT('바로가기_클릭', e)}
                className="w-full"
              >
                <UrlLink url={menuItem.shortcutHomeUrl}>
                  <ShortcutHomeButton
                    shortcutHomeType={menuItem.shortcutHomeType}
                  />
                </UrlLink>
              </div>
            );
          })}
        </div>
      </div>
      {shortcutList?.map((shortcutItemList, index) => {
        return (
          <div key={index} className="mt-10pxr">
            <div className="flex w-full items-center justify-between p-15pxr pb-7pxr">
              <Text className="font-medium1-bold text-theme-solid-100">
                {shortcutItemList?.title}
              </Text>
              {shortcutItemList?.totalCount && (
                <Text className="font-small2 text-theme-solid-40">
                  {t('screen_direct_content_series_count', {
                    values: {
                      value: formatWithCommas(shortcutItemList.totalCount),
                    },
                  })}
                </Text>
              )}
            </div>
            <div className="grid grid-cols-2 gap-4pxr px-11pxr">
              {shortcutItemList?.list.map((shortcutItem, index) => {
                return (
                  <div
                    key={index}
                    {...putTiaraObjectProps({
                      click: {
                        layer1: '바로가기',
                        ordnum: String(index + 1),
                        copy: `${shortcutItemList?.title}_${shortcutItem.title}`,
                      },
                      customProps: {
                        landing_path: shortcutItem.scheme,
                      },
                    })}
                    onClickCapture={e => LOG_CLICK_EVENT('바로가기_클릭', e)}
                  >
                    <SchemeLink scheme={shortcutItem.scheme}>
                      <ShortcutButton
                        shortcutIconType={shortcutItem.icon ?? undefined}
                        shortcutText={shortcutItem.title}
                      />
                    </SchemeLink>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
